import React from 'react';
import { useNavigate } from 'react-router-dom';
import UnifiedSearchPage from '../../components/common/UnifiedSearchPage';
import { fetchWorkOrders } from '../../services/dataService';
import usePageTitle from '../../utils/usePageTitle';

const WorkOrder = () => {
  usePageTitle('Work Order');
  const navigate = useNavigate();
  
  const getRowLink = (row) => `/work-order/${row.projectCode}`;

  const handleRowClick = (row) => {
    navigate(getRowLink(row));
  };

  const columns = [
    { key: 'projectCode', label: 'Project Code' },
    { key: 'budgetCode', label: 'Budget Code' },
    { key: 'requestorName', label: 'Requestor Name' },
    { key: 'personInCharge', label: 'Person In Charge' },
    { key: 'modelName', label: 'Model Name' },
    { key: 'projectStatus', label: 'Project Status' }
  ];

  return (
    <UnifiedSearchPage
      title="Work Order"
      columns={columns}
      onRowClick={handleRowClick}
      getRowLink={getRowLink}
      loadDataFunction={fetchWorkOrders}
    />
  );
};

export default WorkOrder;